import React from 'react';
import { Popover } from 'antd';

// 单元格显示tip增强
const cellRenderEnhancer = ({
    overlayClassName = 'contract-pop',
    placement = 'right',
    renderContent = () => undefined
} = {}) => (next) => (text, record, index) => {
    const content = renderContent(record);
    if (content) {
        return (
            <Popover
                placement={placement}
                overlayClassName={overlayClassName}
                content={content}
            >
                <div>
                    <i className='pop ' />
                    {next ? next(text, record, index) : text}
                </div>
            </Popover>
        );
    }

    return next ? next(text, record, index) : text;
}

export const beforeChangeEnhancer = (next) => (record) => {
    const content = next(record);
    if (content) {
        return `变更前: ${content}`;
    }
 };

export default cellRenderEnhancer;


// WEBPACK FOOTER //
// ./src/components/shared/cellRenderEnhancer.js